export default "__VITE_ASSET__ac4ced4b__"